import { defaultBitlayerProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/bitlayer/default-constants';

export const MACARON_CONTRACT_ADDRESS = '0xB0Cc30795f9E0125575742cFA8e73D20D9966f81';

export const MACARON_PROVIDER_CONFIGURATION = defaultBitlayerProviderConfiguration;
